import React from 'react';

function TableBody({ data, ComponentDaRenderizzare }) {
    return (
        <tbody>
            {data.map((rowData, index) => {
                return <ComponentDaRenderizzare key={index} data={rowData} />;
            })}
        </tbody>
    );
}

export default TableBody;
